import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { MOCKUP_URL } from '../../data/images';
const included = ['6 volumi', '5 bonus', 'Tutto in italiano'];
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-charcoal px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-99" data-mp="9whbbgn3xup5">
      <div className="mx-auto max-w-4xl" data-id="element-100" data-mp="523dz8ovxdhu">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-rose" data-id="element-101" data-mp="iv1m7vmff02t">
          La tua prossima lezione non deve richiedere ore di preparazione.
        </p>
        <h2 id="final-heading" className="mx-auto mt-4 font-display text-[2.6rem] font-bold leading-[1.04] text-brand-ivory sm:text-[3.4rem]" data-id="element-102" data-mp="stimjj798r1j">
          Prepara. Insegna. <em className="italic text-brand-rose" data-id="element-103" data-mp="2ukvmruya2ar9">Fatto.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-104" data-mp="2un8363oe0d27">
          Ottieni il sistema completo Lash & Brow Instructor Ready™ e trasforma ore di preparazione in
          un modo di insegnare più rapido e organizzato.
        </p>

        <img src={MOCKUP_URL} alt="Il sistema completo Lash & Brow Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.45))'
      }} data-id="element-105" data-mp="2vhe1qbqt6g6l" />

        <CtaBlock label="Organizza le tue prossime lezioni" tone="dark" className="mt-10" data-id="element-106" data-mp="3e6kiht81kxpr" />

        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-107" data-mp="3j66xa73iqm0o">
          {included.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-ivory/70" data-id="element-108" data-mp="3n6qs340mddjn">
              <CheckIcon className="h-3.5 w-3.5 text-brand-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-109" data-mp="1ou0eam4dv0xt" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl font-display text-[1.3rem] italic leading-snug text-brand-ivory/80" data-id="element-110" data-mp="2w4551r4kvst1">
          Creato per le professioniste Lash & Brow che vogliono dedicare meno tempo alla preparazione — e
          più tempo all'insegnamento.
        </p>
      </div>
    </section>;
}